// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
body {
  --bs-body-bg: #e9ecef;
}

body {
  background-color: #e9ecef;
  min-height: 100vh;
}

#root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.breakdown-row .breakdown-link {
  border-bottom: 1px dashed transparent;
  transition: color 120ms ease, border-color 120ms ease;
}

.breakdown-row:hover .breakdown-link,
.breakdown-row:focus-visible .breakdown-link {
  color: var(--bs-primary);
  border-bottom-color: var(--bs-primary);
}

.breakdown-row:focus-visible {
  outline: none;
}
.breakdown-row:focus-visible .breakdown-link {
  outline: 2px solid var(--bs-primary);
  outline-offset: 2px;
  border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,qDAAqD;AACvD;;AAEA;;EAEE,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[":root,\nbody {\n  --bs-body-bg: #e9ecef;\n}\n\nbody {\n  background-color: #e9ecef;\n  min-height: 100vh;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.breakdown-row .breakdown-link {\n  border-bottom: 1px dashed transparent;\n  transition: color 120ms ease, border-color 120ms ease;\n}\n\n.breakdown-row:hover .breakdown-link,\n.breakdown-row:focus-visible .breakdown-link {\n  color: var(--bs-primary);\n  border-bottom-color: var(--bs-primary);\n}\n\n.breakdown-row:focus-visible {\n  outline: none;\n}\n.breakdown-row:focus-visible .breakdown-link {\n  outline: 2px solid var(--bs-primary);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
